export var BANK_INFORMATION_TRANSLATIONS = {
    bankInformation: {
        fields: {
            accountOwnerName: 'Nome do titular da conta',
            bankingEntity: 'Selecione um banco',
            accountOwnerIdType: 'Tipo de identificação',
            accountOwnerId: 'Identidade do titular da conta',
            accountType: 'Tipo de conta',
            accountDigit: 'Dígito Verificador da Conta',
            agency: 'Agência',
            verificationCode: 'Dígito Verificador da Agência',
            accountNumber: 'Número da conta',
            taxResidence: 'Domicílio fiscal',
            phonePrefix: 'Código de país',
            phone: 'Telefone de contato',
            accountOwnerEmail: 'E-mail de faturamento',
            cci: 'CCI',
            paymentsAuthorization: 'Declaro e aceito que os pagamentos da marca/filial sejam feitos na conta bancária listada nesta seção.',
            errors: {
                paymentsAuthorization: 'Deve aceitar os termos e condições',
            },
            tooltips: {
                bankingEntity: 'Bancos que não estão na lista não são aceitos atualmente pelo Rappi',
                taxResidence: 'Endereço de registro da conta',
                phone: 'Insira o número de contato do restaurante',
            },
        },
        information: {
            br: '<b>Atenção ao Preenchimento:</b> Para garantir o recebimento correto dos pagamentos, observe as seguintes orientações: Aceitamos apenas contas correntes para o cadastro. Se você é Microempreendedor Individual (MEI), utilize sua conta corrente pessoal (CPF do representante legal). Empresas que não sejam MEI devem fornecer uma conta corrente jurídica (CNPJ). Preencha com cuidado para evitar erros que possam atrasar seus pagamentos.',
        },
    },
};
